import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { SharedService } from "./shared.service";
import { filter, interval, startWith, switchMap } from "rxjs";
import { AuthService } from "./auth.service";
import { environment } from "src/environments/environment";


@Injectable({
	providedIn: 'root'
})
export class ChatService {

	private sharedService = inject(SharedService);
	private authService = inject(AuthService);
	private http = inject(HttpClient);

	lastChatDate = signal<string | null>(null);
	hasBeenSeen = signal<boolean>(true);
	last?:string;

	// private TIMEOUT_SECONDS = 5; // prod
	// private TIMEOUT_SECONDS = 60; // devel
	private TIMEOUT_SECONDS = environment.production ? 30 : 120;
	private TIMEOUT_LAST:number = 1000 * this.TIMEOUT_SECONDS; // segundos

	constructor() {
		interval(this.TIMEOUT_LAST)
		.pipe(
			startWith(0),
			filter(() => this.authService.is_logged_in()),
			switchMap(() => this.http.get<any>(this.sharedService.urls.chats.last))
		)
		.subscribe({
			next: (res) => {
				if (!res.error) {
					if (this.last !== res.last) {
						this.last = res.last;
						this.lastChatDate.set(res.last);
					}
					this.hasBeenSeen.set(res.seen);
				}
			},
			error: (err) => {
				console.error('getLastChat error', err);
			}
		});
	}

}
	
